/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Active/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Active({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub/People/Person/AccountStatus/Active"
  
}) {
  return null
}